//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import PanierList from '../../../components/location/panierList/PanierList.jsx';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TextField from '@mui/material/TextField';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CircularProgress from '@mui/material/CircularProgress';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//data
import { openingHours } from '../../../data/location-params'

//Translate utils :
import { translator } from "../../../utils/translator.js"

import convertHoraire from '../../../utils/convert_horaire'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'

//// - we get infos from the DB to show editables infos for a Resa ////
function LocationMatchConfirm() { // full page as component imported in router

    const { refLoc, idLoc } = useParams(); //id of the selected resa, in url (as string)

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [currentLoc, setCurrentLoc] = useState({});

    const lang = "fr" //global state : shopping step

    const [panier, setPanier] = useState([])
    const [client, setClient] = useState({})
    const [dbArticles, setDbArticles] = useState([])
    const [dbTailles, setDbTailles] = useState([])
    const [reponseCommentaire, setReponseCommentaire] = useState("")
    let [loading, setLoading] = useState(false);
    let [match, setMatch] = useState(false);

    //// -- At first render :
    useEffect(() => {

        /* 
                if (checkLogin() === false) {
                    navigate(`/manager/login?dest=manager`)
                } */


        async function initArticles() {
            const resp = await axios.get(`${baseURL}/article`);
            setDbArticles(resp.data);
            console.log(resp.data)

            initTailles()
        }
        initArticles()

        async function initTailles() {
            const resp = await axios.get(`${baseURL}/taille`);
            setDbTailles(resp.data);

            initLocation()
        }


        async function initLocation() {
            const resp = await axios.get(`${baseURL}/location/${idLoc}`);
            //console.log(resp.data)
            setCurrentLoc(resp.data);
            //control "sécu"
            if (resp.data.ref_location !== refLoc) {
                navigate(`/location`)
            }
        }


    }, [])
    //// --

    //// -- At first render :
    useEffect(() => {

        if (currentLoc.Client) {
            setClient(currentLoc.Client);
        }
        if (currentLoc.Paniers) {
            setPanier(currentLoc.Paniers);
        }

    }, [currentLoc])
    //// --








    return (
        <div className="bg-relative">
            <Background ind={3} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner mode="location" />

                    <section>

                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>Statut de la location</h3>

                                <div className="location-step3-infos-confirm">
                                    <div>
                                        <h4 className={currentLoc.match === true ? "loc-acceptee" : "loc-refusee"}>{currentLoc.match === true ? <CheckIcon /> : <DoNotDisturbIcon />} Cette location a été <strong>{currentLoc.match === true ? " acceptée " : " refusée "}</strong></h4>

                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>Coordonnées client</h3>

                                <div className="location-step3-infos-client-content">
                                    <div>
                                        <h4>{client.prenom + " " + client.nom}</h4>
                                        <p>{"Téléphone : " + client.tel}</p>
                                        <p>{"Email : " + client.email}</p>

                                    </div>
                                    <div>
                                        <p>{"Téléphone 2 : " + client.tel2}</p>
                                        {client.adresse_vacances != "" ?
                                            <p>{"Adresse de vacances : " + client.adresse_vacances}</p>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="main-container">

                            <div className="location-step3-infos-periode">
                                <h3>Durée de location</h3>

                                <div className="location-step3-infos-periode-content">
                                    <div>
                                        <p>Du {dayjs(currentLoc.d1).format("dddd DD/MM")} à {convertHoraire(currentLoc.h1, "horaire")}</p>
                                    </div>
                                    <div>
                                        <p>Au {dayjs(currentLoc.d2).format("dddd DD/MM")} à {convertHoraire(currentLoc.h2, "horaire")}</p>
                                    </div>
                                    <div>
                                        <h4>soit {getDureeInfos(calculDuree(currentLoc))}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main-container">

                            <div className="location-step3-panier-title">
                                <h3>Le panier</h3>

                            </div>
                            <PanierList dbArticles={dbArticles} dbTailles={dbTailles} panierAMatcher={panier} locAMatcher={currentLoc} />

                        </div>


                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>Commentaire</h3>

                                {currentLoc.commentaire && currentLoc.commentaire.length > 0 &&
                                    <div className="location-step3-commentaire">
                                        <div>
                                            <p>Commentaire du client : {currentLoc.commentaire.split("&&")[0]}</p>
                                        </div>
                                        <div>
                                            <p>Réponse de wally : {currentLoc.commentaire.split("&&")[currentLoc.commentaire.split("&&").length - 1]}</p>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>

                    </section>


                </div>
            </main>

        </div>

    );
}

export default LocationMatchConfirm;

